import { IRouteConfigWithMeta } from '@/router/interfaces';

export default [
  {
    path: '/sign-in',
    name: 'auth.signIn',
    meta: {
      template: 'AuthTemplate',
      analyticsName: 'registration',
    },
    component: () => import('@/views/Auth/SignIn.vue'),
  },
  {
    path: '/admin-sign-in',
    name: 'auth.adminSignIn',
    meta: {
      template: 'AuthTemplate',
    },
    component: () => import('@/views/Auth/SignIn.vue'),
  },
] as IRouteConfigWithMeta[];
